import DocsCenter from '../components/DocsCenter'
import { docsContent, docsSectionToPath } from '../config/docs-content'
import { useLanguage } from '../contexts/LanguageContext'

const Docs = () => {
  const { language } = useLanguage()
  const currentDocs = docsContent[language] || docsContent.zh

  return (
    <DocsCenter
      key={language}
      docsData={currentDocs}
      sectionToPath={docsSectionToPath}
      basePath="/docs"
    />
  )
}

export default Docs
